module.exports = __webpack_public_path__ + "06c82233530029a7bf8eeafaf39d5aaf.pdf";